import { render, staticRenderFns } from "./UserTagKeysNew.vue?vue&type=template&id=68c34411&"
import script from "./UserTagKeysNew.vue?vue&type=script&lang=js&"
export * from "./UserTagKeysNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports